import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

interface FlashMessageOptions {
  cssClass?: string;
  timeout?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FlashMessageWrapperService {
  constructor(private toastr: ToastrService) {}

  show(message: string, options?: FlashMessageOptions): void {
    const cssClass = options?.cssClass || '';
    const timeout = options?.timeout || 3000;

    const toastrOptions: Partial<IndividualConfig> = {
      timeOut: timeout,
      closeButton: false,
      progressBar: false,
      positionClass: 'toast-top-center'
    };

    if (cssClass.includes('alert-success')) {
      this.toastr.success(message, '', toastrOptions);
    } else if (cssClass.includes('alert-danger') || cssClass.includes('alert-error')) {
      this.toastr.error(message, '', toastrOptions);
    } else if (cssClass.includes('alert-warning')) {
      this.toastr.warning(message, '', toastrOptions);
    } else if (cssClass.includes('alert-info')) {
      this.toastr.info(message, '', toastrOptions);
    } else {
      this.toastr.show(message, '', toastrOptions);
    }
  }
}